import { render, staticRenderFns } from "./AdminThreadForm.vue?vue&type=template&id=333862b4&"
import script from "./AdminThreadForm.vue?vue&type=script&lang=js&"
export * from "./AdminThreadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports